import React, { Component } from 'react';
import { Table, Input, Select, Button, message, Popconfirm } from 'antd';
import $ from '../../../common/AjaxRequest';
import ExportUtil from '../../../common/ExportUtil';
import UpdateDevelop from './UpdateDevelop';
import API_URL from '../../../common/url';

const { Option } = Select;

class Filter extends Component {
    state = {
        searchParams: {}
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search({...searchParams});
    }

    export = () => {
        this.props.export();
    }

    handleKeyPress = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleInputChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams });
    }

    render() {
        const { searchParams: { employeeCode, userCompellation, developmentType } } = this.state;
        return (
            <div className="filter-bar">
                <div className="form-item">
                    <label className="ui-label">工号</label>
                    <Input
                        placeholder="请输入"
                        value={employeeCode}
                        onKeyPress={this.handleKeyPress}
                        onChange={e => this.handleInputChange(e, 'employeeCode')}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">姓名</label>
                    <Input
                        placeholder="请输入"
                        value={userCompellation}
                        onKeyPress={this.handleKeyPress}
                        onChange={e => this.handleInputChange(e, 'userCompellation')}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">开发类型</label>
                    <Select
                        placeholder="请选择"
                        value={developmentType}
                        allowClear={true}
                        style={{width: 140}}
                        onChange={value => this.handleSelectChange(value, 'developmentType')}
                    >
                        <Option value="NEW">新医院新科室开发</Option>
                        <Option value="EXIST">已有医院新科室开发</Option>
                    </Select>
                </div>
                <div className="form-item">
                    <Button type="primary" onClick={this.export}>导出</Button>
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        )
    }
}

class Develop extends Component {
    state = {
        sortParams: {},
        searchParams: {},
        pagination: {
            current: 1,
            pageSize: 3,
        },
        loading: false,
        data: [],
        subData: {},
        subSortParams: {},
        expandedRowKeys: [],
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { pagination, sortParams, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryNewlyHospitalDepartmentUserList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount = 0 } = res;
                pagination.total = totalCount;

                const expandedRowKeys = [];
                const values = Object.values(searchParams);
                if (values.some(i => !!i)) {
                    datas.forEach(i => expandedRowKeys.push(i.userId));
                }

                this.setState({
                    data: datas,
                    pagination,
                    loading: false,
                    expandedRowKeys,
                    subSortParams: {},
                }, () => {
                    expandedRowKeys.forEach(i => this.loadSubData(i));
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    loadSubData = (userId) => {
        const { searchParams, subSortParams } = this.state;
        const sortParams = subSortParams[userId] || {};
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryNewlyHospitalDepartmentListByUserId,
            data: {
                ...searchParams,
                ...sortParams,
                userId,
            },
            dataType: 'json',
            doneResult: res => {
                const { subData } = this.state;
                subData[userId] = res.newlyHospitalDepartments;
                this.setState({
                    subData,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    subDelete = (row) => {
        const { userId, newlyHospitalDepartmentId } = row;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.deleteNewlyHospitalDepartment,
            data: { newlyHospitalDepartmentId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadSubData(userId);
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    search = searchParams => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { pagination, sortParams, searchParams } = this.state;
        ExportUtil.export({ ...sortParams, ...searchParams }, pagination, API_URL.user.exportNewlyHospitalDepartmentList);
    }

    getRender = (type, options) => {
        if (type === 'date') {
            return text => text ? text.slice(0, 10) : '';
        } else if (type === 'toChinese') {
            // 转中文
            const { contrastList } = options;
            return (text, record) => {
                return text ? (contrastList.find(i => i.value === text) || {}).name : '';
            }
        }
    }

    getColumns = () => {
        const columns = [{
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            sorter: true,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
        }, {
            title: '职位/级别',
            dataIndex: 'positionName',
            key: 'positionName',
        }, {
            title: '手机号码',
            dataIndex: 'userMobile',
            key: 'userMobile',
        }, {
            title: '邮箱',
            dataIndex: 'email',
            key: 'email',
        }, {
            title: '工作城市',
            dataIndex: 'workCity',
            key: 'workCity',
        }, {
            title: '操作',
            dataIndex: 'operate',
            key: 'operate',
            width: 140,
            render: (text, record) => {
                return <a onClick={() => this.showUpdateDevelop(record)}>添加新开发医院科室</a>;
            }
        }];
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map((item, index) => ({
            index: index + 1,
            ...item,
        }));
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field ;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    onExpand = (expanded, record) => {
        const { userId } = record;
        const { expandedRowKeys } = this.state;
        if (expandedRowKeys.length == 0) {
            expandedRowKeys.push(userId);
        } else {
            if (expanded) {
                expandedRowKeys.push(userId);
            } else {
                const index = expandedRowKeys.findIndex(i => i == userId);
                (index || index === 0) && expandedRowKeys.splice(index, 1);
            }
        }
        this.setState({ expandedRowKeys });
        if (expanded) {
            this.loadSubData(userId);
        }
    }

    expandedRowRender = (record) => {
        const { userId } = record;
        const { subData } = this.state;
        const data = subData[userId] || [];

        const getColumns = () => {
            const columns = [{
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
            }, {
                title: '成功开发时间',
                dataIndex: 'successfulDevelopmentTime',
                key: 'successfulDevelopmentTime',
                width: 110,
                sorter: true,
                render: this.getRender('date'),
            }, {
                title: '开发类型',
                dataIndex: 'developmentType',
                key: 'developmentType',
                width: 130,
                render: this.getRender('toChinese', {
                    contrastList: [{
                        value: 'NEW',
                        name: '新医院新科室开发'
                    }, {
                        value: 'EXIST',
                        name: '已有医院新科室开发'
                    }],
                }),
            }, {
                title: '医院名称',
                dataIndex: 'hospitalName',
                key: 'hospitalName',
                width: 160,
            }, {
                title: '科室',
                dataIndex: 'departmentName',
                key: 'departmentName',
                width: 80,
            }, {
                title: '等级',
                dataIndex: 'hospitalLevel',
                key: 'hospitalLevel',
                width: 80,
            }, {
                title: '省',
                dataIndex: 'hospitalProvince',
                key: 'hospitalProvince',
                width: 60,
            }, {
                title: '市',
                dataIndex: 'hospitalCity',
                key: 'hospitalCity',
                width: 60,
            }, {
                title: '详细地址',
                dataIndex: 'hospitalAddress',
                key: 'hospitalAddress',
                width: 120,
            }, {
                title: '确认状态',
                dataIndex: 'confirmStatus',
                key: 'confirmStatus',
                width: 70,
                render: this.getRender('toChinese', {
                    contrastList: [{
                        value: 'ACTIVE',
                        name: '已确认'
                    }, {
                        value: 'INACTIVE',
                        name: '未确认'
                    }],
                }),
            }, {
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 80,
                render: (text, row) => {
                    const { confirmStatus } = row;
                    return (
                        <span>
                            {
                                confirmStatus == 'ACTIVE' ?
                                    <a disabled={true}>修改</a>
                                :
                                    <a onClick={() => this.showUpdateDevelop(record, row)}>修改</a>
                            }
                            <span className="ant-divider" />
                            {
                                confirmStatus == 'ACTIVE' ?
                                    <a disabled={true}>删除</a>
                                :
                                    <Popconfirm title="确定要删除吗?" onConfirm={() => this.subDelete(row)}>
                                        <a>删除</a>
                                    </Popconfirm>
                            }
                        </span>
                    )
                }
            }];
            return columns;
        }
    
        const getDataSource = () => {
            const dataSource = [];
            data.map((item, index) => {
                dataSource.push({
                    index: index + 1,
                    ...item,
                });
            });
            return dataSource;
        };

        const handleTableChange = (pagination, filters, sorter) => {
            const { subSortParams } = this.state;
            const sortParams = subSortParams[userId] || {};
            sortParams.sort = sorter.field;
            sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
            subSortParams[userId] = sortParams;
            this.setState({
                subSortParams,
            }, () => {
                this.loadSubData(userId);
            });
        };

        return (
            <Table
                rowKey={record => record.index}
                columns={getColumns()}
                dataSource={getDataSource()}
                pagination={false}
                scroll={{ x: 1000, y: 300 }}
                onChange={handleTableChange}
            />
        );
    }

    showUpdateDevelop = (parentParams, params) => {
        this.updateDevelopRef.show(parentParams, params);
    }

    render() {
        const { loading, pagination, expandedRowKeys } = this.state;
        return (
            <div>
                <Filter search={this.search} export={this.export} />
                <Table
                    bordered
                    loading={loading}
                    scroll={{x: 1080}}
                    pagination={pagination}
                    columns={this.getColumns()}
                    dataSource={this.getDataSource()}
                    rowKey={row => row.userId}
                    onChange={this.handleTableChange}
                    onExpand={this.onExpand}
                    expandedRowKeys={expandedRowKeys}
                    expandedRowRender={this.expandedRowRender}
                />
                <UpdateDevelop ref={el => this.updateDevelopRef = el} loadData={this.loadSubData} />
            </div>
        );
    }
}

export default Develop;


// WEBPACK FOOTER //
// ./src/components/user/teamManageEvaluate/Develop.js